import {BaseService} from "./base.service";

class StatescitiesService extends BaseService {
    constructor() {
        super('api/states-cities');
    }

    getCitiesByState(state_id) {
        return this.http.get(`api/get-cities-by-state/${state_id}`).then(response => response.data).catch(err => err.message);
    }

}

export const statescitiesService = new StatescitiesService();
